import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';

const SessionExpiredHandler: React.FC = () => {
  const [open, setOpen] = useState(false);
  const firedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => {
      if (firedRef.current) return;
      firedRef.current = true;
      setOpen(true);
    };
    window.addEventListener('session-expired', handler);
    return () => window.removeEventListener('session-expired', handler);
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('user');
    navigate('/auth');
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }}>
        Session expired. Please log in again.
      </Alert>
    </Snackbar>
  );
};

export default SessionExpiredHandler;
